import clsx from "clsx";
import React from "react";

import ArrowSlimIcon from "~/components/Icons/svg/arrow-slim";

import styles from "./infoBlock.less";

interface InfoBlockIProps {
  data: string;
  variant?: string | null;
  label: string;
  result?: number;
  switcher?: boolean;
  customValue?: string;
}

const InfoItemBlock: React.FC<InfoBlockIProps> = ({
  variant,
  data,
  label,
  result = 0,
  switcher = false,
  customValue,
}) => {
  return (
    <div
      className={clsx(
        styles.infoCard,
        data === variant ? styles.infoCardActive : styles.infoCardInactive,
      )}
      data-variant={data}
    >
      <p className={styles.titleCard}>{label}</p>
      <span className={styles.infoCount}>
        {customValue !== undefined ? customValue : result}
      </span>
      {switcher && (
        <div className={styles.infoSwitcher}>
          <span>{data === variant ? "Скрыть" : "Подробнее"}</span>
          <div
            className={clsx(
              data === variant
                ? styles.infoSwitcherWrapperIconHidden
                : styles.infoSwitcherWrapperIconVisible,
            )}
          >
            <ArrowSlimIcon size={"10"} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoItemBlock;
